export const ADD_OPTION = 'add';
export const EDIT_OPTION = 'edit';
export const SHOW_OPTION = 'show';
export const DELETE_OPTION = 'delete';